import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { SingleFilterOption } from '../filters/enums/single-filter-option.enum';


@Pipe({
  name: 'filterSingleOptionDisplayName',
  standalone: true,
})
export class FilterSingleOptionDisplayNamePipe implements PipeTransform {

  private translationMap = {
    [SingleFilterOption.WITHOUT_SUBEQUIPMENTS]:
      this.languageService.getInstant('modules.equipment.equipmentList.withoutSubequipments'),
    [SingleFilterOption.VEHICLE_ONLY]:
      this.languageService.getInstant('modules.equipment.equipmentList.transportVehiclesOnly'),
    [SingleFilterOption.FAVOURITE_ONLY]:
      this.languageService.getInstant('modules.equipment.equipmentList.favouriteEquipmentsOnly'),
    [SingleFilterOption.ONLY_LATEST_COMPLETED_FOR_RULE]:
      this.languageService.getInstant('modules.maintenance.base.onlyLatestCompletedForRule'),
    [SingleFilterOption.ALL_LABELS]:
      this.languageService.getInstant('modules.equipment.equipmentList.flexibleMatch'),
    [SingleFilterOption.ONLY_DISPOSITION_GEOFENCES]:
      this.languageService.getInstant('shared.geofence.dispositionOnly'),
  };

  constructor(private languageService: LanguageService) { }

  public transform(value: SingleFilterOption): string {
    return this.translationMap[value] ?? value;
  }
}
